import type { StyleSystemProps } from '@withjoy/joykit';
import { styled, Flex, Box } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledDivider = styled.div`
  border-top: 1px solid #fff;
`;

export const StyledSwitchEventButton = styled(Flex)`
  text-underline-offset: 3px;
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.mono5};
  :hover {
    text-decoration-color: ${({ theme }) => theme.colors.mono8};
  }
  :active {
    text-decoration-color: ${({ theme }) => theme.colors.mono14};
  }
`;
const switchEventButtonStyels: StyleSystemProps = {
  fontWeight: 600,
  cursor: 'pointer',
  color: 'mono14',
  transition: animationTransition('color'),
  textAlign: ['left', null, 'center'],
  padding: 0,
};

export const StyledLinkButton = styled(Box)`
  :hover,
  :focus {
    background: rgba(0, 0, 0, 0.02);
  }

  svg {
    margin-right: ${props => props.theme.space[3]};
  }
`;
const linkButtonStyles: StyleSystemProps = {
  display: 'inline-flex',
  alignItems: 'center',
  transition: animationTransition('background'),
  paddingX: 5,
  paddingY: 4,
  width: '100%',
  textAlign: 'left',
};

export const PlaceholderPhoto = styled(Flex)``;
const placeholderPhotoStyles: StyleSystemProps = {
  size: [pxToRem(71), null, pxToRem(104)],
  backgroundColor: 'mono3',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '100%',
};

export const Wrapper = styled(Flex)``;
const wrapperStyles: StyleSystemProps = {
  flexDirection: ['row', null, 'column'],
  justifyContent: ['flex-start', null, 'center'],
  textAlign: ['left', null, 'center'],
  paddingY: [4, null, 5],
  paddingX: 5,
  marginBottom: [5, null, 0],
  alignItems: 'center',
  columnGap: 6,
  rowGap: 6,
};

export const styles = {
  switchEventButton: switchEventButtonStyels,
  linkButton: linkButtonStyles,
  placeholderPhoto: placeholderPhotoStyles,
  wrapper: wrapperStyles,
};
